import { render, staticRenderFns } from "./EditStockDialogMobile.vue?vue&type=template&id=544abd28&scoped=true&"
import script from "./EditStockDialogMobile.vue?vue&type=script&lang=js&"
export * from "./EditStockDialogMobile.vue?vue&type=script&lang=js&"
import style0 from "./EditStockDialogMobile.vue?vue&type=style&index=0&id=544abd28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544abd28",
  null
  
)

export default component.exports